import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Circle from "../assets/img/check_circle.svg";
import Cycle from "../assets/img/cycle.svg";
import { useState } from "react";
import { useNavigate } from "react-router";
import RichTextEditorField from "./RichTextEditorField";

const validationSchema = Yup.object({
  employerEmailId: Yup.string().required("Email is required").email("Invalid email address"),
  emailSubject :Yup.string().required("Subject is Required"),
  dynamicEmailBody: Yup.string().required("Please enter email body"),
  sendEmail: Yup.string().required(),
  testEmailId: Yup.string().when("sendEmail", {
    is: "yes",
    then: (schema) =>
      schema.required("Test Email is required").email("Invalid test email address"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

const EmployerConfirmPopup = (props) => {
  const { setshowEmployerPopup, employerFormSubmit, updateStatus, updateStatusType, rotaDealInformation, userDetails, dynamicEmailBody,employerEmailPopup } = props;
  const [submitType, setSubmitType] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const navigate = useNavigate();

  return (
    <div className="confirmLetter">
      <div
        className="popup-overlay"
        onClick={() => setshowEmployerPopup(false)}
      >
        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
          <button
            className="close-btn"
            onClick={() => setshowEmployerPopup(false)}
          >
            &times;
          </button>
          <h2 className="popupTitle">Customize Email?</h2>
          <Formik
            initialValues={{
              employerEmailId: employerEmailPopup || userDetails.survey.contact_email,
              emailSubject : `Without Prejudice FAO: ${userDetails.survey.contact_name} Re: ${userDetails.name}`,
              dynamicEmailBody: dynamicEmailBody.employerEmailBody + dynamicEmailBody.lawyerSignature,
              dynamicEmailBodyEmployee: dynamicEmailBody.employeeEmailBody + dynamicEmailBody.lawyerSignature,
              sendEmail: "no",
              testEmailId: "",
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => {
              setIsLoading(true);
              await employerFormSubmit(values, submitType);
              setIsLoading(false);
              if (submitType === "liveLetter") {
                navigate("/request-submitted");
              }
            }}
          >
            {({ values, setFieldValue, setFieldTouched }) => (
              <Form className="formWrap">
                <div className="testEmailIdwrap margin-20">
                  <h3>Sender Email ID : {rotaDealInformation.deal_owner_email_id}</h3>
                  <h3>Sender Name : {rotaDealInformation.deal_owner_name}</h3>
                  {/* <h3>Client Email : {userDetails.email}</h3>
                  <h3>Client Name : {userDetails.name}</h3> */}
                </div>
                
                {/* Question 1 */}
                <div className="testEmailIdwrap margin-20">
                  <h3>Employer Email ID : </h3>
                  <Field
                      type="text"
                      name="employerEmailId"
                      placeholder="Employer Email ID"
                    />
                    <ErrorMessage
                      name="employerEmailId"
                      component="div"
                      className="error"
                    />
                </div>

                {/* Question 2 */}
                <div className="testEmailIdwrap margin-20">
                  <h3>Email Subject : </h3>
                  <Field
                    className="subjectBox"
                      type="text"
                      name="emailSubject"
                      placeholder="Email Subject"
                    /> - {`[Our ref: ${rotaDealInformation.dealRef}]`}
                    <ErrorMessage
                      name="emailSubject"
                      component="div"
                      className="error"
                    />
                </div>
                {/* Question 3 */}
                <div className="textAreaWrap margin-20">
                  <h3>Employer email body:</h3>
                  <RichTextEditorField
                    extraClass="bodySignDynamic"
                    value={values.dynamicEmailBody}
                    onChange={(val) => setFieldValue("dynamicEmailBody", val)}
                  />
                </div>
                <div className="textAreaWrap margin-20">
                  <h3>Client email body:</h3>
                  <RichTextEditorField
                    extraClass="bodySignDynamic"
                    value={values.dynamicEmailBodyEmployee}
                    onChange={(val) => setFieldValue("dynamicEmailBodyEmployee", val)}
                  />
                </div>
                {/* Question 2 */}
                <div className="radioGroup margin-20">
                  <h3>Do you want to send a preview email?</h3>
                  <div className="radioWrap">
                    <Field type="radio" name="sendEmail" value="yes" /> Yes
                    <Field type="radio" name="sendEmail" value="no" /> No
                  </div>
                  <ErrorMessage
                    name="sendEmail"
                    component="div"
                    className="error"
                  />
                </div>
                {/* Conditional Email Input */}
                {values.sendEmail === "yes" && (
                  <div className="testEmailIdwrap margin-20">
                    <h3>Enter preview email ID:</h3>
                    <Field
                      type="email"
                      name="testEmailId"
                      placeholder="Email ID"
                    />
                    <ErrorMessage
                      name="testEmailId"
                      component="div"
                      className="error"
                    />
                  </div>
                )}
                {updateStatus && (<div className={`confirmMessage ${updateStatusType}`}>{updateStatus}</div>)}
                <div className="actionWrap">
                  {values.sendEmail === "yes" && (
                    <button
                      type="submit"
                      className="testButton"
                      onClick={() => setSubmitType("testLetter")}
                    >
                      Send preview email
                    </button>
                  )}
                  <button
                    type="submit"
                    className="testButton employerEmail"
                    onClick={() => setSubmitType("liveLetter")}
                  >
                    <img src={Circle} width="auto" height="auto" alt="circle" />
                    Send letter to employer
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        {isLoading && (
          <div className="submit-loader">
            <div>
              <img src={Cycle} width="auto" height="auto" alt="cycle" />
              <p>Submitting</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployerConfirmPopup;
